import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    large_hrd: {
        marginTop: theme.spacing(2),
        width: theme.spacing(15),
        height: theme.spacing(6)
    },
    paper: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(7),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
}));

export default function Header() {
    const classes = useStyles();
    return (
        <div className={classes.paper}>
            <div style={{ display: 'flex', width: '100%', justifyContent: "space-around" }}>
                <Avatar alt="Job Fair Logo" src="/participant/logo512.png" variant="square" className={classes.large} />
                <Avatar alt="Hrd Logo" src="https://jobfair.jababeka.com/img/logo@2x.png" variant="square" className={classes.large_hrd} />
            </div>
            <Typography component="h1" variant="h6" style={{ textAlign: 'center' }}>
                KAWASAN INDUSTRI JABABEKA
        </Typography>
            <Typography variant="subtitle1" style={{ textAlign: 'center' }}>
                PROUDLY PRESENT
        </Typography>
            <Typography component="h1" variant="h6" gutterBottom style={{ textAlign: 'center', fontWeight: 'bold', marginTop: '3%' }}>
                VIRTUAL JOB FAIR & SCHOLARSHIP HUNT 2021
        </Typography>
        </div>
    )
}